export interface PageMetaItem {
  title: string;
  desc: string;
  keywords: string;
}

export const MODULE_META_CATALOG: Record<string, PageMetaItem> = {
  modules: {
    title: 'Platform Modules',
    desc: 'Luminix enterprise aviation safety, quality assurance, regulatory compliance, operations, and governance module catalog.',
    keywords: 'modules, luminix, platform, aviation sms, qms, safety, quality, compliance, governance',
  },
  admin: {
    title: 'Platform Modules',
    desc: 'Luminix enterprise aviation safety, quality assurance, regulatory compliance, operations, and governance module catalog.',
    keywords: 'modules, luminix, platform, aviation sms, qms, safety, quality, compliance, governance',
  },
  administration: {
    title: 'Organization & System Settings',
    desc: 'Organization configuration, regional preferences, department hierarchy, email configuration, and governance policies.',
    keywords: 'administration, system settings, organization settings, email configuration, departments, governance policies',
  },
  dashboard: {
    title: 'Executive Dashboard & Cockpit',
    desc: 'Executive safety cockpit, operational KPI indicators, SPI alerts, and personal My Work desk summary.',
    keywords: 'dashboard, cockpit, kpi, spi, safety indicators, my work, luminix, executive summary',
  },
  user_profile: {
    title: 'User Profile & System Settings',
    desc: 'Personal account details, authorized modules, roles, and credential security configuration.',
    keywords: 'user profile, system settings, authorized modules, roles, account info, change password, luminix',
  },
  profile: {
    title: 'User Profile & System Settings',
    desc: 'Personal account details, authorized modules, roles, and credential security configuration.',
    keywords: 'user profile, system settings, authorized modules, roles, account info, change password, luminix',
  },
  analysis: {
    title: 'Custom Analysis & Flexible Dashboards',
    desc: 'Interactive customized analytics dashboard builder with drag-and-drop widgets, threshold alerts, dynamic cross-filtering, and multi-dimensional metrics.',
    keywords: 'analysis, analytics, custom dashboard, visual builder, widgets, cross-filtering, charts, recharts, safety metrics',
  },
  risks: {
    title: 'Risk Assessment & Bowtie Analysis',
    desc: 'ICAO Doc 9859 5x5 risk matrix heatmap, safety barriers, ALARP evaluation, and visual Bowtie analysis.',
    keywords: 'risk management, risk matrix, bowtie, 5x5, alarp, safety barriers, icao doc 9859, residual risk',
  },
  bowtie: {
    title: 'Bowtie Visual Safety Barrier Model',
    desc: 'Dual-wing visual Bowtie diagram, hazard precursors, prevention barriers, top event, and recovery mitigations.',
    keywords: 'bowtie diagram, visual safety barriers, top event, threat, mitigation, prevention barrier',
  },
  hazards: {
    title: 'Hazard Identification & Register',
    desc: 'Active hazard register, operational context, precursor threats, and risk assessment linkages.',
    keywords: 'hazard identification, hazard register, operational risk, safety precursors',
  },
  occurrences: {
    title: 'Occurrences',
    desc: 'Mandatory (MOR) and voluntary safety occurrence reports, classification, triage, and initial risk grading.',
    keywords: 'occurrences, safety events, mor, incident, accident, triage, mandatory reporting, investigation',
  },
  assess_report: {
    title: 'SMS Assessment Desk | Safety Reports',
    desc: 'Operational SMS intake & assessment: file as Info Only, issue Corrective Actions (CAPA), or initiate formal Safety Investigations (Annex 13).',
    keywords: 'safety assessment, sms triage, occurrence classification, corrective action, investigation',
  },
  ingestion: {
    title: 'Safety Reports',
    desc: 'Central safety report intake, multi-step reporting wizard, anonymous submissions, and confidentiality vault quarantine.',
    keywords: 'safety report, reporting wizard, anonymous reporting, safety reporting portal, confidential reporting',
  },
  tasks_actions: {
    title: 'Central Tasks & Actions',
    desc: 'Central work queue, three-tier action verification (implemented, verified, effective), and checklist execution.',
    keywords: 'tasks, actions, capa, work queue, verification, checklists',
  },
  surveys: {
    title: 'Surveys & Safety Culture Checklists',
    desc: 'Safety culture surveys, question bank, operational checklists, and anonymous risk flagging triggers.',
    keywords: 'surveys, checklists, question bank, safety culture, operational verification',
  },
  workflows: {
    title: 'Automated Workflows & Approvals',
    desc: 'Process orchestration engine, Segregation of Duties (SoD) approvals, and workflow simulation runtime.',
    keywords: 'workflows, automation, sod, approval engine, orchestration, segregation of duties',
  },
  reports: {
    title: 'Reports & Regulatory Filing',
    desc: 'Report definitions, execution history, cryptographically signed snapshots, and regulatory authority submissions.',
    keywords: 'reports, regulatory filing, audit report, cryptographic snapshot, authority submission',
  },
  analytics: {
    title: 'Analytics & Predictive Intelligence',
    desc: 'OLAP analytical models, governed metrics, 3-sigma control limits, and machine learning forecasting.',
    keywords: 'analytics, olap, 3-sigma, machine learning, trend analysis, forecasting, governed metrics',
  },
  assets: {
    title: 'Aviation Assets & Fleet Management',
    desc: 'Aircraft CAMO, fleet management, ground support equipment (GSE), calibrated tools, and Part-145 maintenance tracking.',
    keywords: 'aircraft, fleet, camo, gse, part-145, calibration, aviation assets, ground support equipment',
  },
  training: {
    title: 'Training & Competency Management',
    desc: 'Training requirements, course catalog, recurrent currency tracking, and operational effectiveness evaluation.',
    keywords: 'training, competency, recurrent currency, course catalog, training effectiveness, certification',
  },
  documents: {
    title: 'Controlled Documents Management',
    desc: 'Controlled document lifecycle, revision history, distribution lists, and mandatory read-and-sign acknowledgments.',
    keywords: 'document management, sop, revision control, controlled copy, distribution list, acknowledgment',
  },
  meetings: {
    title: 'Meetings & Safety Review Boards (SRB / SAG)',
    desc: 'Safety Review Board (SRB), Safety Action Group (SAG), quorum tracking, approved minutes, and linked actions.',
    keywords: 'srb, sag, safety committee, meeting minutes, decision log, quorum',
  },
  moc: {
    title: 'Management of Change (MOC)',
    desc: 'Multi-domain impact assessment, rollback plans, Post-Implementation Review (PIR), and SoD signoffs.',
    keywords: 'moc, management of change, impact assessment, rollback plan, pir, approval signoff',
  },
  initiatives: {
    title: 'Strategic & Continuous Improvement Initiatives',
    desc: 'Safety and quality continuous improvement projects, milestones, KPI impact tracking, and board reviews.',
    keywords: 'initiatives, continuous improvement, strategic projects, sms, qms, milestones',
  },
  monitoring: {
    title: 'Compliance Monitoring & Assurance',
    desc: 'Independent compliance monitoring reviews, sample evaluations, and formal assurance statements.',
    keywords: 'compliance monitoring, sample evaluation, assurance statement, independent review',
  },
  matrix: {
    title: 'Compliance & Traceability Matrix',
    desc: 'Traceability matrix mapping regulatory requirements, internal procedures (SOPs), and audit evidence.',
    keywords: 'compliance matrix, traceability, regulatory mapping, sop, audit evidence',
  },
  obligations: {
    title: 'Permits & Compliance Obligations',
    desc: 'Recurring operating permit and license obligations, validity schedules, and formal evidence registry.',
    keywords: 'compliance obligations, permits, licenses, evidence registry, validity schedule',
  },
  regulations: {
    title: 'Regulations & Directives Library',
    desc: 'Organization-level regulatory compliance rules, operational directives, and closed-loop change management.',
    keywords: 'regulations library, directives, regulatory compliance, closed-loop change',
  },
  regulatory: {
    title: 'Regulatory Frameworks (EASA / FAA / ICAO / SHGM)',
    desc: 'International and national aviation regulatory rule libraries, applicability matrices, and internal control links.',
    keywords: 'easa, faa, icao, shgm, aviation standards, regulatory frameworks',
  },
  capas: {
    title: 'CAPA Management (8D)',
    desc: 'Corrective and Preventive Actions (CAPA), 8D problem-solving methodology, and post-closure effectiveness checks.',
    keywords: 'capa, corrective action, preventive action, 8d problem solving, effectiveness verification',
  },
  findings: {
    title: 'Quality Findings & Non-Conformities',
    desc: 'Audit and inspection findings, Level 1/2/3 non-conformity grading, and root cause analysis (RCA).',
    keywords: 'quality findings, non-conformity, level 1, level 2, root cause analysis, rca',
  },
  inspections: {
    title: 'Operational Inspections',
    desc: 'Ramp inspections, station evaluations, checklist execution, and non-conformity grading.',
    keywords: 'operational inspection, ramp inspection, station audit, checklist scoring',
  },
  audits: {
    title: 'Quality Audits & Annual Programme',
    desc: 'Annual quality audit programme, auditor independence (SoD), checklists, and audit report signoffs.',
    keywords: 'quality audits, annual audit programme, auditor independence, audit report',
  },
  performance: {
    title: 'Safety Performance Indicators (SPI / SPT)',
    desc: 'Safety objectives, SPI catalog, 1σ/2σ/3σ alert thresholds, and Safety Review Board (SRB) targets.',
    keywords: 'spi, spt, safety performance, alert thresholds, 3-sigma, srb targets',
  },
  actions: {
    title: 'Safety Mitigation Actions',
    desc: 'Risk mitigation actions, overdue ageing tracking, and multi-stage closure verification gates.',
    keywords: 'safety actions, mitigation, action tracking, ageing, closure gates',
  },
  investigations: {
    title: 'Safety Investigations Workspace',
    desc: 'Incident investigations, 5-Why root cause analysis, Bowtie root cause bridge, and evidence custody log.',
    keywords: 'investigations, 5-why, root cause analysis, incident log, evidence custody',
  },
  roles: {
    title: 'Role Based Access Control (RBAC)',
    desc: 'Dynamic RBAC authorization engine, role templates, organizational scoping, email configuration, and permission audit.',
    keywords: 'roles, permissions, rbac, access control, role templates, email configuration',
  },
  integration_attempts: {
    title: 'Integration Hub & Telemetry',
    desc: 'Message execution attempts, integration telemetry, controlled retries, and dead-letter queue (DLQ) monitoring.',
    keywords: 'integration hub, telemetry, retry, dead-letter queue, webhook, api integration',
  },
  help: {
    title: 'Help & Support Center (FAQ & Knowledge Base)',
    desc: 'Frequently Asked Questions, organization-specific procedures, and technical support ticketing.',
    keywords: 'help, support, faq, knowledge base, tickets, technical support, documentation',
  },
  login: {
    title: 'Sign In',
    desc: 'Luminix Safety & Quality Management System secure authentication and organization selection.',
    keywords: 'sign in, login, authentication, luminix, aviation safety',
  },
  not_found: {
    title: '404 Page Not Found',
    desc: 'The requested safety, quality, or compliance module could not be found.',
    keywords: '404, page not found, invalid route, module not found',
  },
};

/**
 * Updates all relevant head meta tags dynamically:
 * - document.title
 * - meta[name="description"]
 * - meta[name="keywords"]
 * - meta[property="og:title"]
 * - meta[property="og:description"]
 * - meta[property="og:url"]
 * - meta[name="twitter:title"]
 * - meta[name="twitter:description"]
 */
export function setPageMeta(meta: PageMetaItem): void {
  const fullTitle = `${meta.title} | Luminix Safety & Quality`;
  document.title = fullTitle;

  const setOrCreateMeta = (attrName: string, attrVal: string, content: string) => {
    let el = document.querySelector(`meta[${attrName}="${attrVal}"]`);
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute(attrName, attrVal);
      document.head.appendChild(el);
    }
    el.setAttribute('content', content);
  };

  // Standard Meta Tags
  setOrCreateMeta('name', 'description', meta.desc);
  setOrCreateMeta('name', 'keywords', meta.keywords);

  // Open Graph Tags
  setOrCreateMeta('property', 'og:title', fullTitle);
  setOrCreateMeta('property', 'og:description', meta.desc);
  setOrCreateMeta('property', 'og:url', window.location.href);

  // Twitter Card Tags
  setOrCreateMeta('name', 'twitter:title', fullTitle);
  setOrCreateMeta('name', 'twitter:description', meta.desc);
}
